export default {
  About: '关于',
  Resume: '简历',
  Projects: '项目',
  Stats: '统计',
  Contact: '联络我',
  aboutMe: '关于我',

  resume: '简历',
  education: '教育背景',
  experience: '工作经验',
  achievements: '获奖情况',
  skills: '技能',
  tools: '工具',
  references: '参考',

  Couperin_degree: '高中毕业, 科学组',
  Fenelon_degree: '两年数学精英大学校预备班',
  EMSE_degree: '精英大学校工程学士 - 微电子专业',

  unbabel_company: 'Unbabel',
  unbabel_position: '英语到法语翻译',
  unbabel_point0: '翻译来自不同公司和行业的各种类型的文件和文本',
  unbabel_point1: '从简单的翻译做起，然后转为高级编辑，负责最后的核实工作',

  ISM_position: '实习',
  ISM_company: 'Institute of Movement Sciences',
  ISM_point0: '致力于专为剧院演出设计的遥控氦气动力低噪音无人机的设计和制造',
  ISM_point1: '负责设计无人机的 3D 模型，然后创建控制所需电机和传感器的低重量 PCB',
  ISM_point2: '使用 Raspberry Pi Zero 和 Xbox 控制器创建一种控制无人机的简单方法',

  PI_company: 'Saint-Étienne School of Mines - Flexible electronics laboratory',
  PI_position: '工业项目',
  PI_point0: '致力于为连接的可穿戴心电监护仪创建原型',
  PI_point1: '作为一个由两名学生组成的团队，我们使用 STM32WB55 微控制器为该设备创建了概念验证',
  PI_point2: '主要在代码和元器件选型上下功夫, 整机平均功耗从10mW降低到140µW',
};
